export default "__VITE_ASSET__62813a04__"